import { CloudDownloadOutlined } from '@material-ui/icons'
import { downloadBomItemFiles } from 'features/BillOfMaterials/store/asyncActions/downloadBomItemFiles'
import { BomItemMenuItem } from './BomItemMenuItem'

export const DownloadBomItemFilesMenuItem = ({
  bomItemId,
  bomItemType,
  onClose,
}: {
  bomItemId: string
  bomItemType: 'row' | 'assembly' | 'project'
  onClose: () => void
}) => {
  return (
    <BomItemMenuItem
      action={downloadBomItemFiles}
      actionParams={{
        bomItemId,
        bomItemType,
      }}
      primaryTextTranslationKey="project:download-files"
      secondaryTextTranslationKey="project:download-files-description"
      icon={<CloudDownloadOutlined />}
      closeAfterFullfilled
      onClose={onClose}
    />
  )
}
